export default {
  //柱状图颜色
  barColor(grade) {
    let val = parseInt(grade);
    let color = '';
    switch (val) {
      case 3:
        color = 'linear-gradient(180deg, #ac6eff, #6b36d0 90%)';
        break;
      case 1:
        color = 'linear-gradient(180deg, #6891e3, #3357b3 90%)';
        break;
      case 2:
        color = 'linear-gradient(180deg, #4cd8fb, #21a9f7 90%)';
        break;
      case 4:
        color = 'linear-gradient(180deg, #fabf72, #ee7d09 90%)';
        break;
      case 5:
        color = 'linear-gradient(180deg, #f9bc0b, #fba22e 90%)';
        break;
      case 6:
        color = 'linear-gradient(180deg, #b7dd58, #79a702 90%)';
        break;
      case 7:
        color = 'linear-gradient(180deg, #67c381, #3c7e4c 90%)';
        break;
      case 8:
        color = 'linear-gradient(180deg, #ed9d75, #d96b4c 90%)';
        break;
    }
    return color;
  },

  //超越人数百分比颜色
  beyondNum(grade) {
    let val = parseInt(grade);
    let color = '';
    switch (val) {
      case 3:
        color = '#9a52fe';
        break;
      case 1:
        color = '#4476d8';
        break;
      case 2:
        color = '#26c0ea';
        break;
      case 4:
        color = '#f29319';
        break;
      case 5:
        color = '#f9bd2b';
        break;
      case 6:
        color = '#9fc73e';
        break;
      case 7:
        color = '#4d925f';
        break;
      case 8:
        color = '#e17543';
        break;
    }
    return color;
  },

  //等级卡片边框颜色
  borderColor(grade) {
    let val = parseInt(grade);
    let color = '';
    switch (val) {
      case 3:
        color = "#d6b7ff";
        break;
      case 1:
        color = '#b6cfff';
        break;
      case 2:
        color = '#a9edfe';
        break;
      case 4:
        color = '#ffd9a7';
        break;
      case 5:
        color = '#fff0c0';
        break;
      case 6:
        color = '#e8ffae';
        break;
      case 7:
        color = '#b4ffc8';
        break;
      case 8:
        color = '#fec7ad';
        break;
    }
    return color;
  },

  //考试内容剖析颜色
  //学习内容对标颜色
  //QuickReivew颜色
  //未来三个月学习计划
  mainTtleColor(grade) {
    let val = parseInt(grade);
    let color = '';
    switch (val) {
      case 3:
        color = '#6c45a1';
        break;
      case 1:
        color = '#2559bf';
        break;
      case 2:
        color = '#147a94';
        break;
      case 4:
        color = '#935200';
        break;
      case 5:
        color = '#7f4224';
        break;
      case 6:
        color = '#719419';
        break;
      case 7:
        color = '#2c6d3f';
        break;
      case 8:
        color = '#be5928';
        break;
    }
    return color;
  },

  //Echarts中英文颜色
  echartsZhEn(grade) {
    let val = parseInt(grade);
    let color = '';
    switch (val) {
      case 3:
        color = '#7513a7';
        break;
      case 1:
        color = '#174bac';
        break;
      case 2:
        color = '#0a86a6';
        break;
      case 4:
        color = '#bd6c06';
        break;
      case 5:
        color = '#7e4226';
        break;
      case 6:
        color = '#7aa01e';
        break;
      case 7:
        color = '#359d51';
        break;
      case 8:
        color = '#ce5f2a';
        break;
    }
    return color;
  },

  //百分数颜色
  echartsNum(grade) {
    let val = parseInt(grade);
    let color = '';
    switch (val) {
      case 3:
        color = '#af75ff';
        break;
      case 1:
        color = '#4f8aff';
        break;
      case 2:
        color = '#04beef';
        break;
      case 4:
        color = '#fe9202';
        break;
      case 5:
        color = '#f8bd32';
        break;
      case 6:
        color = '#9ddb03';
        break;
      case 7:
        color = '#03c134';
        break;
      case 8:
        color = '#ff5100';
        break;
    }
    return color;
  },

  //底色区域
  splitAreaColor(grade) {
    let val = parseInt(grade);
    let color = '';
    switch (val) {
      case 3:
        color = '#ede0ff';
        break;
      case 1:
        color = '#e6efff';
        break;
      case 2:
        color = '#e5f9fe';
        break;
      case 4:
        color = '#feeacd';
        break;
      case 5:
        color = '#fff5d8';
        break;
      case 6:
        color = '#f1ffce';
        break;
      case 7:
        color = '#e0fee7';
        break;
      case 8:
        color = '#ffe7dd';
        break;
    }
    return color;
  },

  //刻度线
  axisLineColor(grade) {
    let val = parseInt(grade);
    let color = '';
    switch (val) {
      case 3:
        color = '#9e80c7';
        break;
      case 1:
        color = '#9abaf7';
        break;
      case 2:
        color = '#89c8d8';
        break;
      case 4:
        color = '#f3ac4f';
        break;
      case 5:
        color = '#fba22e';
        break;
      case 6:
        color = '#abc963';
        break;
      case 7:
        color = '#6fba83';
        break;
      case 8:
        color = '#e59067';
        break;
    }
    return color;
  },

  splitLineColor(grade) {
    let val = parseInt(grade);
    let color = [];
    switch (val) {
      case 3:
        color = ['#ede0ff', '#ede0ff', '#ede0ff', '#9e80c7', '#ede0ff'];
        break;
      case 1:
        color = ['#e6efff', '#e6efff', '#e6efff', '#9abaf7', '#e6efff'];
        break;
      case 2:
        color = ['#e5f9fe', '#e5f9fe', '#e5f9fe', '#89c8d8', '#e5f9fe'];
        break;
      case 4:
        color = ['#feeacd', '#feeacd', '#feeacd', '#f3ac4f', '#feeacd'];
        break;
      case 5:
        color = ['#fff5d8', '#fff5d8', '#fff5d8', '#fba22e', '#fff5d8'];
        break;
      case 6:
        color = ['#f1ffce', '#f1ffce', '#f1ffce', '#abc963', '#f1ffce'];
        break;
      case 7:
        color = ['#e0fee7', '#e0fee7', '#e0fee7', '#6fba83', '#e0fee7'];
        break;
      case 8:
        color = ['#ffe7dd', '#ffe7dd', '#ffe7dd', '#e59067', '#ffe7dd'];
        break;
    }
    return color;
  },

  //透明覆盖
  areaColor(grade) {
    let val = parseInt(grade);
    let color = '';
    switch (val) {
      case 3:
        color = '#9e80c7';
        break;
      case 1:
        color = '#94b2eb';
        break;
      case 2:
        color = '#7bdcf5';
        break;
      case 4:
        color = '#eeb76a';
        break;
      case 5:
        color = '#fed473';
        break;
      case 6:
        color = '#bedb77';
        break;
      case 7:
        color = '#96c8a3';
        break;
      case 8:
        color = '#e6a183';
        break;
    }
    return color;
  },

  //tab切换栏字体颜色
  tabNormalColor(grade) {
    let val = parseInt(grade);
    let color = '';
    switch (val) {
      case 3:
        color = '#8e66d2';
        break;
      case 1:
        color = '#6583c7';
        break;
      case 2:
        color = '#589bae';
        break;
      case 4:
        color = '#b78958';
        break;
      case 5:
        color = '#ac7f47';
        break;
      case 6:
        color = '#99b659';
        break;
      case 7:
        color = '#699f77';
        break;
      case 8:
        color = '#be7f66';
        break;
    }
    return color;
  },

  //tab高亮和下划线颜色
  tabHeightLightColor(grade) {
    let val = parseInt(grade);
    let color = '';
    switch (val) {
      case 3:
        color = '#5c15bd';
        break;
      case 1:
        color = '#174bad';
        break;
      case 2:
        color = '#066d87';
        break;
      case 4:
        color = '#935200';
        break;
      case 5:
        color = '#7f4224';
        break;
      case 6:
        color = '#6f9419';
        break;
      case 7:
        color = '#2c6d3f';
        break;
      case 8:
        color = '#a14b21';
        break;
    }
    return color;
  },

  //analyzeCard标题颜色
  acTitle(grade) {
    let val = parseInt(grade);
    let color = '';
    switch (val) {
      case 3:
        color = '#9714bd';
        break;
      case 1:
        color = '#2680c9';
        break;
      case 2:
        color = '#0a9bc1';
        break;
      case 4:
        color = '#b87317';
        break;
      case 5:
        color = '#da791f';
        break;
      case 6:
        color = '#64830d';
        break;
      case 7:
        color = '#04972f';
        break;
      case 8:
        color = '#9c411c';
        break;
    }
    return color;
  },

  //analyzeCard百分比颜色
  acNum(grade) {
    let val = parseInt(grade);
    let color = '';
    switch (val) {
      case 3:
        color = '#9a52fe';
        break;
      case 1:
        color = '#4476d8';
        break;
      case 2:
        color = '#10bfec';
        break;
      case 4:
        color = '#f29518';
        break;
      case 5:
        color = '#f7bb2e';
        break;
      case 6:
        color = '#9fc73e';
        break;
      case 7:
        color = '#4d925f';
        break;
      case 8:
        color = '#e17543';
        break;
    }
    return color;
  },

  //analyzeCard进度条颜色
  acProcess(grade) {
    let val = parseInt(grade);
    let color = '';
    switch (val) {
      case 3:
        color = '#9e57fe';
        break;
      case 1:
        color = '#5385e4';
        break;
      case 2:
        color = '#29c8f1';
        break;
      case 4:
        color = '#f39c2b';
        break;
      case 5:
        color = '#fdd059';
        break;
      case 6:
        color = '#a2c943';
        break;
      case 7:
        color = '#56a06a';
        break;
      case 8:
        color = '#e58b60';
        break;
    }
    return color;
  },

  srBackground(grade) {
    let val = parseInt(grade);
    let color = '';
    switch (val) {
      case 3:
        color = '#e7d5ff';
        break;
      case 1:
        color = '#e6effe';
        break;
      case 2:
        color = '#e9f9fd';
        break;
      case 4:
        color = '#fdeacd';
        break;
      case 5:
        color = '#fff0bf';
        break;
      case 6:
        color = '#f1ffce';
        break;
      case 7:
        color = '#e0fee7';
        break;
      case 8:
        color = '#ffe7db';
        break;
    }
    return color;
  },

  srCircle(grade) {
    let val = parseInt(grade);
    let color = '';
    switch (val) {
      case 3:
        color = '#5c15bd';
        break;
      case 1:
        color = '#174bad';
        break;
      case 2:
        color = '#066d87';
        break;
      case 4:
        color = '#935200';
        break;
      case 5:
        color = '#eea102';
        break;
      case 6:
        color = '#6f9419';
        break;
      case 7:
        color = '#2c6d3f';
        break;
      case 8:
        color = '#a14922';
        break;
    }
    return color;
  },

  srTitle(grade) {
    let val = parseInt(grade);
    let color = '';
    switch (val) {
      case 3:
        color = '#492379';
        break;
      case 1:
        color = '#204287';
        break;
      case 2:
        color = '#165a8d';
        break;
      case 4:
        color = '#8b5815';
        break;
      case 5:
        color = '#9d673';
        break;
      case 6:
        color = '#628116';
        break;
      case 7:
        color = '#1f6532';
        break;
      case 8:
        color = '#864221';
        break;
    }
    return color;
  },

  srText(grade) {
    let val = parseInt(grade);
    let color = '';
    switch (val) {
      case 3:
        color = '#9a52fe';
        break;
      case 1:
        color = '#4476d8';
        break;
      case 2:
        color = '#26c0ea';
        break;
      case 4:
        color = '#f29319';
        break;
      case 5:
        color = '#f9bf2f';
        break;
      case 6:
        color = '#9fc73e';
        break;
      case 7:
        color = '#4d925f';
        break;
      case 8:
        color = '#e17543';
        break;
    }
    return color;
  },

  srButton(grade) {
    let val = parseInt(grade);
    let color = '';
    switch (val) {
      case 3:
        color = '#9b60ed';
        break;
      case 1:
        color = '#b8cffc';
        break;
      case 2:
        color = '#b7f0fe';
        break;
      case 4:
        color = '#fee7c7';
        break;
      case 5:
        color = '#fabf2e';
        break;
      case 6:
        color = '#eaffb4';
        break;
      case 7:
        color = '#c4ffd3';
        break;
      case 8:
        color = '#ffe1d2';
        break;
    }
    return color;
  },

  srButtonText(grade) {
    let val = parseInt(grade);
    let color = '';
    switch (val) {
      case 3:
        color = '#5c15bd';
        break;
      case 1:
        color = '#174bad';
        break;
      case 2:
        color = '#116d86';
        break;
      case 4:
        color = '#935200';
        break;
      case 5:
        color = '#d9781f';
        break;
      case 6:
        color = '#6f9419';
        break;
      case 7:
        color = '#2c6d3f';
        break;
      case 8:
        color = '#a14922';
        break;
    }
    return color;
  },

  srButtonShadow(grade) {
    let val = parseInt(grade);
    let color = '';
    switch (val) {
      case 3:
        color = '0 3pX 0 0 #672ecb';
        break;
      case 1:
        color = '0 3pX 0 0 #5d83cb';
        break;
      case 2:
        color = '0 3pX 0 0 #2b7e98';
        break;
      case 4:
        color = '0 3pX 0 0 #ab793b';
        break;
      case 5:
        color = '0 3pX 0 0 #de7f1e';
        break;
      case 6:
        color = '0 3pX 0 0 #97b94f';
        break;
      case 7:
        color = '0 3pX 0 0 #599c64';
        break;
      case 8:
        color = '0 3pX 0 0 #bd7f59';
        break;
    }
    return color;
  },
  warn(x) {
    return require('../assets/imgs/' + x + '/更多.png');
  },
  tip() {
    return require('../assets/imgs/tip.png');
  }
}



// WEBPACK FOOTER //
// ./src/config/color.js